// /*!
//  * Halloween Bats Intro (bats only)
//  * - No background, no text, no buttons. Only bats over your live website.
//  * - Random bats fly, then one big bat zooms in until the screen is fully black,
//  *   then the black fades out and the website is revealed.
//  *
//  * Install: add this before </body>
//  *   <script src="halloween-bats.js" defer></script>
//  *
//  * Optional settings (put BEFORE the script tag):
//  *   <script>window.HALLOWEEN_BATS = { flyMs: 2600, zoomMs: 1500, fadeMs: 1000, oncePerSession: false };</script>
//  */
// (function () {
//   var cfg = window.HALLOWEEN_BATS || {};
//   var FLY_MS   = cfg.flyMs   != null ? cfg.flyMs   : 2600; // random flying time before the big bat
//   var ZOOM_MS  = cfg.zoomMs  != null ? cfg.zoomMs  : 1500; // big bat zoom time
//   var HOLD_MS  = cfg.holdMs  != null ? cfg.holdMs  : 150;  // fully black hold
//   var FADE_MS  = cfg.fadeMs  != null ? cfg.fadeMs  : 1000; // fade to reveal website
//   var MAX_BATS = cfg.maxBats != null ? cfg.maxBats : 32;
//   var ONCE     = !!cfg.oncePerSession;                     // true = only first visit in a session

//   if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
//   try { if (ONCE && sessionStorage.getItem('hw-bats-seen') === '1') return; } catch (e) {}

//   function run() {
//     var canvas = document.createElement('canvas');
//     canvas.setAttribute('aria-hidden', 'true');
//     canvas.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;z-index:2147483000;pointer-events:none;opacity:1;transition:opacity ' + FADE_MS + 'ms ease';
//     document.body.appendChild(canvas);
//     var ctx = canvas.getContext('2d');
//     var W = 0, H = 0, dpr = 1, bats = [], raf = 0, t0 = 0, last = 0, hero = null, ended = false, running = true;

//     var rand = function (a, b) { return a + Math.random() * (b - a); };
//     var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

//     function resize() {
//       dpr = Math.min(window.devicePixelRatio || 1, 2);
//       W = window.innerWidth; H = window.innerHeight;
//       canvas.width = W * dpr; canvas.height = H * dpr;
//       ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
//     }
//     window.addEventListener('resize', resize);
//     resize();

//     function makeBat(entering) {
//       var depth = rand(0.4, 1.5), x, y, heading;
//       if (entering) {
//         var s = Math.floor(Math.random() * 4);
//         if (s === 0) { x = -120; y = rand(0, H * 0.9); } else if (s === 1) { x = W + 120; y = rand(0, H * 0.9); }
//         else if (s === 2) { x = rand(0, W); y = -120; } else { x = rand(0, W); y = H + 120; }
//         heading = Math.atan2(H / 2 - y, W / 2 - x) + rand(-1, 1);
//       } else { x = rand(0, W); y = rand(0, H); heading = rand(0, Math.PI * 2); }
//       return {
//         x: x, y: y, depth: depth,
//         size: 0.34 * depth * Math.min(1, Math.max(0.6, W / 900)),
//         speed: rand(100, 200) * (0.6 + depth * 0.5),
//         heading: heading, turn: 0, turnTarget: rand(-1.4, 1.4), turnTimer: rand(0.4, 1.6),
//         flapPhase: rand(0, 6.28), flapRate: rand(9, 14) / (0.7 + depth * 0.35),
//         glide: 0, glideTimer: rand(1, 4), bob: rand(0, 6.28)
//       };
//     }
//     var n = Math.round(clamp(W / 55, 14, MAX_BATS));
//     for (var i = 0; i < n; i++) bats.push(makeBat(false));
//     bats.sort(function (a, b) { return a.depth - b.depth; });

//     function wing(L, a) {
//       var c = Math.cos, s = Math.sin;
//       function P(r, g, o) { return [r * c(g), -r * s(g) + o]; }
//       var tip = P(L, a, 0), el = P(L * 0.52, a * 0.6 + 0.22, -5), p1 = P(L * 0.80, a * 0.85, 24),
//           p2 = P(L * 0.55, a * 0.6, 32), p3 = P(L * 0.30, a * 0.3, 28);
//       function sc(f, t) { return [(f[0] + t[0]) / 2 * 0.97, (f[1] + t[1]) / 2 - 9]; }
//       var cp;
//       ctx.beginPath(); ctx.moveTo(3, -6);
//       ctx.quadraticCurveTo(el[0], el[1], tip[0], tip[1]);
//       cp = sc(tip, p1); ctx.quadraticCurveTo(cp[0], cp[1], p1[0], p1[1]);
//       cp = sc(p1, p2);  ctx.quadraticCurveTo(cp[0], cp[1], p2[0], p2[1]);
//       cp = sc(p2, p3);  ctx.quadraticCurveTo(cp[0], cp[1], p3[0], p3[1]);
//       ctx.quadraticCurveTo(10, 30, 5, 14); ctx.closePath(); ctx.fill();
//       ctx.beginPath();
//       ctx.moveTo(3, -6); ctx.lineTo(p1[0], p1[1]);
//       ctx.moveTo(3, -4); ctx.lineTo(p2[0], p2[1]);
//       ctx.moveTo(3, -2); ctx.lineTo(p3[0], p3[1]);
//       ctx.stroke();
//     }
//     function drawBatAt(x, y, scale, flap, rot, alpha, eyes) {
//       ctx.save(); ctx.translate(x, y); ctx.rotate(rot); ctx.scale(scale, scale); ctx.globalAlpha = alpha;
//       ctx.fillStyle = '#050208'; ctx.strokeStyle = '#2b1236'; ctx.lineWidth = 1.8; ctx.lineCap = 'round';
//       for (var side = 1; side >= -1; side -= 2) { ctx.save(); ctx.scale(side, 1); wing(78, flap); ctx.restore(); }
//       ctx.beginPath(); ctx.ellipse(0, 6, 8.5, 17, 0, 0, 6.283); ctx.fill();
//       ctx.beginPath(); ctx.arc(0, -13, 7.5, 0, 6.283); ctx.fill();
//       ctx.beginPath();
//       ctx.moveTo(-7, -16); ctx.lineTo(-10, -31); ctx.lineTo(-1, -20);
//       ctx.moveTo(7, -16);  ctx.lineTo(10, -31);  ctx.lineTo(1, -20);
//       ctx.fill();
//       if (eyes) { ctx.fillStyle = '#ff6a1a'; ctx.beginPath(); ctx.arc(-2.8, -14, 1.4, 0, 6.283); ctx.arc(2.8, -14, 1.4, 0, 6.283); ctx.fill(); }
//       ctx.restore();
//     }

//     function stepBats(dt) {
//       for (var i = 0; i < bats.length; i++) {
//         var b = bats[i]; b.turnTimer -= dt;
//         if (b.turnTimer <= 0) { b.turnTarget = rand(-2.2, 2.2); b.turnTimer = rand(0.35, 1.5); }
//         b.turn += (b.turnTarget - b.turn) * Math.min(1, dt * 3); b.heading += b.turn * dt;
//         b.glideTimer -= dt;
//         if (b.glideTimer <= 0) {
//           if (b.glide > 0) { b.glide = 0; b.glideTimer = rand(1.5, 4); } else { b.glide = 1; b.glideTimer = rand(0.25, 0.6); }
//         }
//         b.flapPhase += b.flapRate * dt * (b.glide > 0 ? 0 : 1); b.bob += dt * 3;
//         b.x += Math.cos(b.heading) * b.speed * dt; b.y += Math.sin(b.heading) * b.speed * dt + Math.sin(b.bob) * 0.6;
//         if (b.x < -180 || b.x > W + 180 || b.y < -180 || b.y > H + 180) bats[i] = makeBat(true);
//       }
//     }
//     function drawFlock() {
//       for (var i = 0; i < bats.length; i++) {
//         var b = bats[i], flap = b.glide > 0 ? 0.35 : Math.sin(b.flapPhase) * 0.85 + 0.1;
//         var rot = clamp(Math.cos(b.heading) * 0.35 + b.turn * 0.15, -0.5, 0.5);
//         drawBatAt(b.x, b.y, b.size, flap, rot, Math.min(1, 0.6 + b.depth * 0.4), b.depth > 1.0);
//       }
//     }

//     function drawHero(now) {
//       var p = clamp((now - hero.t) / ZOOM_MS, 0, 1);
//       var s0 = 0.3 * Math.min(1, Math.max(0.7, W / 900)), s1 = Math.max(W, H) / 7;
//       var scale = s0 * Math.pow(s1 / s0, Math.pow(p, 1.7));
//       var ep = 1 - Math.pow(1 - p, 2);
//       var x = (W / 2 + hero.ox) + (W / 2 - (W / 2 + hero.ox)) * ep;
//       var y = H * 0.42 + (H * 0.5 - H * 0.42) * ep;
//       hero.phase += (12 + p * 14) * 0.016;
//       drawBatAt(x, y, scale, Math.sin(hero.phase) * 0.85 + 0.1, Math.sin(now / 260) * 0.08 * (1 - p), 1, true);
//       var k = clamp((p - 0.8) / 0.2, 0, 1); // make sure the screen ends 100% black
//       if (k > 0) { ctx.save(); ctx.globalAlpha = k * k; ctx.fillStyle = '#050208'; ctx.fillRect(-50, -50, W + 100, H + 100); ctx.restore(); }
//       return p;
//     }

//     function finish() {
//       if (ended) return; ended = true;
//       canvas.style.opacity = '0'; // website is revealed as the black fades
//       try { sessionStorage.setItem('hw-bats-seen', '1'); } catch (e) {}
//       setTimeout(function () {
//         running = false; cancelAnimationFrame(raf);
//         window.removeEventListener('resize', resize);
//         if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
//       }, FADE_MS + 80);
//     }

//     function frame(now) {
//       if (!running) return;
//       var dt = Math.min(0.05, (now - last) / 1000 || 0.016); last = now;
//       ctx.clearRect(0, 0, W, H);
//       stepBats(dt);
//       if (!hero && now - t0 >= FLY_MS) hero = { t: now, phase: 0, ox: rand(-0.08, 0.08) * W };
//       var p = 0, shake = 0;
//       if (hero) { p = clamp((now - hero.t) / ZOOM_MS, 0, 1); if (p > 0.55) shake = (p - 0.55) / 0.45 * 12; }
//       ctx.save();
//       if (shake) ctx.translate(rand(-shake, shake), rand(-shake, shake));
//       drawFlock();
//       if (hero) p = drawHero(now);
//       ctx.restore();
//       if (hero && p >= 1 && !ended && !frame.wait) { frame.wait = setTimeout(finish, HOLD_MS); }
//       raf = requestAnimationFrame(frame);
//     }

//     document.addEventListener('visibilitychange', function () {
//       if (ended) return;
//       if (document.hidden) { running = false; cancelAnimationFrame(raf); }
//       else { running = true; last = performance.now(); raf = requestAnimationFrame(frame); }
//     });

//     t0 = last = performance.now();
//     raf = requestAnimationFrame(frame);
//   }

//   if (document.body) run();
//   else document.addEventListener('DOMContentLoaded', run);
// })();



/*!
 * Halloween Bats Intro (bats only, plays once per session)
 * - No background, no text, no buttons. Only bats over your live website.
 * - Random bats fly, then one big bat zooms in until the screen is fully black,
 *   then the black fades out and the website is revealed.
 * - Plays once per browser session: it will NOT replay on page reload or on
 *   other pages, until the visitor closes their browser tab and opens a new one.
 *
 * Install: add this line before </body>
 *   <script src="halloween-bats.js" defer></script>
 */
(function () {
  var FLY_MS   = 2600; // random flying time before the big bat (ms)
  var ZOOM_MS  = 1500; // big bat zoom time (ms)
  var HOLD_MS  = 150;  // fully black hold (ms)
  var FADE_MS  = 1000; // fade to reveal website (ms)
  var MAX_BATS = 32;   // max bats on screen at once
  var SEEN_KEY = 'hw-bats-seen';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  try { if (sessionStorage.getItem(SEEN_KEY) === '1') return; } catch (e) {}
  try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {} // mark seen immediately, before it even finishes

  function run() {
    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;z-index:2147483000;pointer-events:none;opacity:1;transition:opacity ' + FADE_MS + 'ms ease';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var W = 0, H = 0, dpr = 1, bats = [], raf = 0, t0 = 0, last = 0, hero = null, ended = false, running = true, waitTimer = 0;

    var rand = function (a, b) { return a + Math.random() * (b - a); };
    var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = W * dpr; canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    window.addEventListener('resize', resize);
    resize();

    function makeBat(entering) {
      var depth = rand(0.4, 1.5), x, y, heading;
      if (entering) {
        var s = Math.floor(Math.random() * 4);
        if (s === 0) { x = -120; y = rand(0, H * 0.9); } else if (s === 1) { x = W + 120; y = rand(0, H * 0.9); }
        else if (s === 2) { x = rand(0, W); y = -120; } else { x = rand(0, W); y = H + 120; }
        heading = Math.atan2(H / 2 - y, W / 2 - x) + rand(-1, 1);
      } else { x = rand(0, W); y = rand(0, H); heading = rand(0, Math.PI * 2); }
      return {
        x: x, y: y, depth: depth,
        size: 0.34 * depth * Math.min(1, Math.max(0.6, W / 900)),
        speed: rand(100, 200) * (0.6 + depth * 0.5),
        heading: heading, turn: 0, turnTarget: rand(-1.4, 1.4), turnTimer: rand(0.4, 1.6),
        flapPhase: rand(0, 6.28), flapRate: rand(9, 14) / (0.7 + depth * 0.35),
        glide: 0, glideTimer: rand(1, 4), bob: rand(0, 6.28)
      };
    }
    var n = Math.round(clamp(W / 55, 14, MAX_BATS));
    for (var i = 0; i < n; i++) bats.push(makeBat(false));
    bats.sort(function (a, b) { return a.depth - b.depth; });

    function wing(L, a) {
      var c = Math.cos, s = Math.sin;
      function P(r, g, o) { return [r * c(g), -r * s(g) + o]; }
      var tip = P(L, a, 0), el = P(L * 0.52, a * 0.6 + 0.22, -5), p1 = P(L * 0.80, a * 0.85, 24),
          p2 = P(L * 0.55, a * 0.6, 32), p3 = P(L * 0.30, a * 0.3, 28);
      function sc(f, t) { return [(f[0] + t[0]) / 2 * 0.97, (f[1] + t[1]) / 2 - 9]; }
      var cp;
      ctx.beginPath(); ctx.moveTo(3, -6);
      ctx.quadraticCurveTo(el[0], el[1], tip[0], tip[1]);
      cp = sc(tip, p1); ctx.quadraticCurveTo(cp[0], cp[1], p1[0], p1[1]);
      cp = sc(p1, p2);  ctx.quadraticCurveTo(cp[0], cp[1], p2[0], p2[1]);
      cp = sc(p2, p3);  ctx.quadraticCurveTo(cp[0], cp[1], p3[0], p3[1]);
      ctx.quadraticCurveTo(10, 30, 5, 14); ctx.closePath(); ctx.fill();
      ctx.beginPath();
      ctx.moveTo(3, -6); ctx.lineTo(p1[0], p1[1]);
      ctx.moveTo(3, -4); ctx.lineTo(p2[0], p2[1]);
      ctx.moveTo(3, -2); ctx.lineTo(p3[0], p3[1]);
      ctx.stroke();
    }
    function drawBatAt(x, y, scale, flap, rot, alpha, eyes) {
      ctx.save(); ctx.translate(x, y); ctx.rotate(rot); ctx.scale(scale, scale); ctx.globalAlpha = alpha;
      ctx.fillStyle = '#050208'; ctx.strokeStyle = '#2b1236'; ctx.lineWidth = 1.8; ctx.lineCap = 'round';
      for (var side = 1; side >= -1; side -= 2) { ctx.save(); ctx.scale(side, 1); wing(78, flap); ctx.restore(); }
      ctx.beginPath(); ctx.ellipse(0, 6, 8.5, 17, 0, 0, 6.283); ctx.fill();
      ctx.beginPath(); ctx.arc(0, -13, 7.5, 0, 6.283); ctx.fill();
      ctx.beginPath();
      ctx.moveTo(-7, -16); ctx.lineTo(-10, -31); ctx.lineTo(-1, -20);
      ctx.moveTo(7, -16);  ctx.lineTo(10, -31);  ctx.lineTo(1, -20);
      ctx.fill();
      if (eyes) { ctx.fillStyle = '#ff6a1a'; ctx.beginPath(); ctx.arc(-2.8, -14, 1.4, 0, 6.283); ctx.arc(2.8, -14, 1.4, 0, 6.283); ctx.fill(); }
      ctx.restore();
    }

    function stepBats(dt) {
      for (var i = 0; i < bats.length; i++) {
        var b = bats[i]; b.turnTimer -= dt;
        if (b.turnTimer <= 0) { b.turnTarget = rand(-2.2, 2.2); b.turnTimer = rand(0.35, 1.5); }
        b.turn += (b.turnTarget - b.turn) * Math.min(1, dt * 3); b.heading += b.turn * dt;
        b.glideTimer -= dt;
        if (b.glideTimer <= 0) {
          if (b.glide > 0) { b.glide = 0; b.glideTimer = rand(1.5, 4); } else { b.glide = 1; b.glideTimer = rand(0.25, 0.6); }
        }
        b.flapPhase += b.flapRate * dt * (b.glide > 0 ? 0 : 1); b.bob += dt * 3;
        b.x += Math.cos(b.heading) * b.speed * dt; b.y += Math.sin(b.heading) * b.speed * dt + Math.sin(b.bob) * 0.6;
        if (b.x < -180 || b.x > W + 180 || b.y < -180 || b.y > H + 180) bats[i] = makeBat(true);
      }
    }
    function drawFlock() {
      for (var i = 0; i < bats.length; i++) {
        var b = bats[i], flap = b.glide > 0 ? 0.35 : Math.sin(b.flapPhase) * 0.85 + 0.1;
        var rot = clamp(Math.cos(b.heading) * 0.35 + b.turn * 0.15, -0.5, 0.5);
        drawBatAt(b.x, b.y, b.size, flap, rot, Math.min(1, 0.6 + b.depth * 0.4), b.depth > 1.0);
      }
    }

    function drawHero(now) {
      var p = clamp((now - hero.t) / ZOOM_MS, 0, 1);
      var s0 = 0.3 * Math.min(1, Math.max(0.7, W / 900)), s1 = Math.max(W, H) / 7;
      var scale = s0 * Math.pow(s1 / s0, Math.pow(p, 1.7));
      var ep = 1 - Math.pow(1 - p, 2);
      var x = (W / 2 + hero.ox) + (W / 2 - (W / 2 + hero.ox)) * ep;
      var y = H * 0.42 + (H * 0.5 - H * 0.42) * ep;
      hero.phase += (12 + p * 14) * 0.016;
      drawBatAt(x, y, scale, Math.sin(hero.phase) * 0.85 + 0.1, Math.sin(now / 260) * 0.08 * (1 - p), 1, true);
      var k = clamp((p - 0.8) / 0.2, 0, 1); // ensure the screen ends 100% black
      if (k > 0) { ctx.save(); ctx.globalAlpha = k * k; ctx.fillStyle = '#050208'; ctx.fillRect(-50, -50, W + 100, H + 100); ctx.restore(); }
      return p;
    }

    function finish() {
      if (ended) return; ended = true;
      canvas.style.opacity = '0'; // website is revealed as the black fades
      setTimeout(function () {
        running = false; cancelAnimationFrame(raf);
        window.removeEventListener('resize', resize);
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      }, FADE_MS + 80);
    }

    function frame(now) {
      if (!running) return;
      var dt = Math.min(0.05, (now - last) / 1000 || 0.016); last = now;
      ctx.clearRect(0, 0, W, H);
      stepBats(dt);
      if (!hero && now - t0 >= FLY_MS) hero = { t: now, phase: 0, ox: rand(-0.08, 0.08) * W };
      var p = 0, shake = 0;
      if (hero) { p = clamp((now - hero.t) / ZOOM_MS, 0, 1); if (p > 0.55) shake = (p - 0.55) / 0.45 * 12; }
      ctx.save();
      if (shake) ctx.translate(rand(-shake, shake), rand(-shake, shake));
      drawFlock();
      if (hero) p = drawHero(now);
      ctx.restore();
      if (hero && p >= 1 && !ended && !waitTimer) { waitTimer = setTimeout(finish, HOLD_MS); }
      raf = requestAnimationFrame(frame);
    }

    document.addEventListener('visibilitychange', function () {
      if (ended) return;
      if (document.hidden) { running = false; cancelAnimationFrame(raf); }
      else { running = true; last = performance.now(); raf = requestAnimationFrame(frame); }
    });

    t0 = last = performance.now();
    raf = requestAnimationFrame(frame);
  }

  if (document.body) run();
  else document.addEventListener('DOMContentLoaded', run);
})();